<template>
  <div class="availability-with-text">
    <div :class="['awt-bubble', { 'awt-bubble--available': available }]" />
    {{ text }}
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    text: string;
    available: boolean;
  }>(),
  {
    text: '',
  },
);
</script>

<style lang="scss" scoped>
.availability-with-text {
  display: flex;
  gap: math.div($pad, 2);
  align-items: center;

  .awt-bubble {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid $color-action-icons-error-default-base;

    &.awt-bubble--available {
      border-color: $color-general-background-status-positive-higher;
      background: $color-general-background-status-positive-higher;
    }
  }
}
</style>
